import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { S3_BUCKET_URL } from '@/constants.ts';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import {
  OptionItemSprite,
  OptionItemSpriteList,
} from '@/pages/Onboarding/components/OptionItemSprite/OptionItemSprite';
import { useOnboarding } from '@/pages/Onboarding/context';
import {
  OwnAiTitle,
  OwnAiTitleHighlight,
} from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { ETHNICITY_FEMALE_OPTIONS } from '@/pages/Onboarding/options/EthnicityFemale';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../../types';

import { EthnicityFemaleStyles } from './EthnicityFemale.styles';

export const ScreenEthnicity: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Ethnicity',
      });
    }
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const ethnicity = form.watch('ethnicity');
  const age = form.watch('age') || '18-24';

  const handleSelect = (option: OnbOptionType<LayoutDataType['ethnicity']>) => {
    form.setValue('ethnicity', option.id);
    userService.createOrUpdate({
      onboarding_data: {
        ethnicity: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  const getImageSrc = (ethnicityId: string) => {
    return `${S3_BUCKET_URL}/layout-own-ai/ethnicity/${ethnicityId}/sprite-${age}.png`;
  };

  return (
    <EthnicityFemaleStyles>
      <OnboardingNavigation />
      <OwnAiTitle>
        Select her <OwnAiTitleHighlight>ethnicity</OwnAiTitleHighlight>
      </OwnAiTitle>

      <IonContent>
        <OptionItemSpriteList>
          {ETHNICITY_FEMALE_OPTIONS.map((option) => (
            <OptionItemSprite
              key={option.id}
              alt="ethnicity"
              isSelected={ethnicity === option.id}
              onClick={() => handleSelect(option)}
              spriteSrc={getImageSrc(option.id)}
              title={option.title}
              TEST_ID={`ethnicity-${option.id}`}
              show
            />
          ))}
        </OptionItemSpriteList>
      </IonContent>
    </EthnicityFemaleStyles>
  );
};
